import React from "react";
import { connect } from "react-redux";

import NameAndRating from '../Commons/NameAndRating';
import defaultAvatar from '../../../images/default-avatar.jpg';

class MyPortfolioIndividual extends React.Component {

    render() {

        const { avatar } = this.props;

        return (
            <div className="tab-content profile-info tab-content1">
                <div className="human-info">
                    {
                        avatar
                        ? <div className="human-info-avatar" style={{ backgroundImage: `url(${avatar})` }} />
                        : <div className="human-info-avatar" style={{ backgroundImage: `url(${defaultAvatar})` }} />
                    }
                    <div className="base-info">
                        <NameAndRating {...this.props} />
                    </div>
                </div>

                {
                    this.props.content ?
                    <div className="human-about-info">
                        {this.props.content}
                    </div>
                    : ''
                }

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(MyPortfolioIndividual);


// WEBPACK FOOTER //
// ./src/components/Profile/SubMyPortfolio/AlienPortfolioIndividual.js